import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=d7f5b48e&"
import script from "./Discounts.vue?vue&type=script&lang=ts&"
export * from "./Discounts.vue?vue&type=script&lang=ts&"
import style0 from "./Discounts.vue?vue&type=style&index=0&id=d7f5b48e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports